import { ColumnDef } from "@tanstack/react-table";
import { HeaderSortable } from "@/components/Base/HeaderSortable";
import {
  ContainerMetricsRow,
  formatDuration,
} from "@/lib/containerMetricsMath";

type DurationColumnKey = Extract<
  keyof ContainerMetricsRow,
  "todaySeconds" | "weekSeconds"
>;

export type DurationColumnConfig = {
  key: DurationColumnKey;
  label: string;
};

export const DURATION_COLUMNS: DurationColumnConfig[] = [
  { key: "todaySeconds", label: "Average Time Today" },
  { key: "weekSeconds", label: "Average Time This Week" },
];

const createDurationColumn = ({
  key,
  label,
}: DurationColumnConfig): ColumnDef<ContainerMetricsRow> => ({
  accessorKey: key,
  meta: { label },
  header: ({ column }) => <HeaderSortable column={column} title={label} />,
  cell: ({ row }) => formatDuration(row.original[key]),
});

export const containerMetricsColumns = (): ColumnDef<ContainerMetricsRow>[] => [
  {
    accessorKey: "containerName",
    meta: { label: "Container" },
    header: ({ column }) => (
      <HeaderSortable column={column} title="Container" />
    ),
    sortingFn: (rowA, rowB) =>
      rowA.original.containerName.localeCompare(rowB.original.containerName),
  },
  ...DURATION_COLUMNS.map(createDurationColumn),
];
